import http from './http'

function mapPage (res) {
  var page = res.data
  return {
    items: page.content || [],
    total: page.totalElements || 0,
    hasMore: !page.last
  }
}

export function sendCollabRequest (payload) {
  return http.post('/collaborations', payload).then(function (res) {
    return res.data
  })
}

export function getReceivedRequests (params) {
  var query = {
    page: params && params.page > 1 ? params.page - 1 : 0,
    size: (params && params.size) || 20
  }
  return http.get('/collaborations/received', { params: query }).then(mapPage)
}

export function getSentRequests (params) {
  var query = {
    page: params && params.page > 1 ? params.page - 1 : 0,
    size: (params && params.size) || 20
  }
  return http.get('/collaborations/sent', { params: query }).then(mapPage)
}

export function acceptCollab (id) {
  return http.post('/collaborations/' + id + '/accept').then(function (res) {
    return res.data
  })
}

export function declineCollab (id) {
  return http.post('/collaborations/' + id + '/decline').then(function (res) {
    return res.data
  })
}
